 <!-- 友情链接start -->
  <template>
  <div class="links">
    <div class="links-box min">
      <div class="links-list">
        <ul>
          <li class="link-text">
            <img class="links-icon" src="../../static/img/lianjie.png" alt />
            友情链接
          </li>
          <li>
            <span class="links-icons">
              <a href="https://www.cast.org.cn/" target="_blank"><img src="../../static/img/keji.png" alt=""></a>
            </span>
          </li>
          <li>
            <span class="links-icons">
              <a href="http://www.sxstm.cn/" target="_blank"><img src="../../static/img/kejiguan.png" alt=""></a>
            </span>
          </li>
          <li>
            <span class="links-icons">
              <a href="http://www.sxast.cn/" target="_blank"><img src="../../static/img/shanxi.png" alt=""></a>
            </span>
          </li>
          <li>
            <span class="links-icons" style="border: none">
              <a href="http://www.jzkjg.com/" target="_blank"><img src="../../static/img/shanxikeji.png" alt=""></a>
            </span>
          </li>
        </ul>
      </div>
      <div class="links-top" @click="backTop"><img src="../../static/img/top.png" alt=""></div>
    </div>
  </div>
</template>
  <script>
export default {
  data() {
    return {};
  },
 mounted () {
  window.addEventListener('scroll', this.scrollToTop)
},
destroyed () {
  window.removeEventListener('scroll', this.scrollToTop)
},
 
 
methods: {
  // 点击图片回到顶部方法，加计时器是为了过渡顺滑
  backTop () {
      const that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
  },
 
  // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
  scrollToTop () {
    const that = this
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    that.scrollTop = scrollTop
    if (that.scrollTop > 0) {
      that.btnFlag = true
    } else {
      that.btnFlag = false
    }
  }
}
};
</script>
<style  scoped>
.links-list ul li{
   height: 40px;
  justify-content: center;
  align-items: center;
}
.links-icons a{
  color: #ffffff;
}
.links-icons a img{
  width: 180px;
  height: 40px;
}
.links-top img{
  width:37px;
  height: 28px;
}
</style>
   


// WEBPACK FOOTER //
// src/components/tab.vue